// extracted by mini-css-extract-plugin
module.exports = {"pcWrap":"pcWrap___3nqD8","mobileWrap":"mobileWrap___1Yg00"};